import type { FileCardAttrs, FileCardLayout } from './fileCard.types';
import { parseDataAttrs } from '@/shared/helpers/parseDataAttrs';

const WORD_EXTS = new Set(['.doc', '.docx']);
const EXCEL_EXTS = new Set(['.xls', '.xlsx', '.csv']);
const PPT_EXTS = new Set(['.ppt', '.pptx']);
const ARCHIVE_EXTS = new Set(['.zip', '.rar', '.7z']);
const IMAGE_EXTS = new Set(['.png', '.jpg', '.jpeg', '.gif', '.webp', '.svg', '.bmp']);
const AUDIO_EXTS = new Set(['.mp3', '.wav', '.ogg', '.aac', '.flac']);
const VIDEO_EXTS = new Set(['.mp4', '.webm', '.mov', '.avi', '.mkv']);

/** Resolve FA icon name by file extension */
export const getFileTypeIcon = (ext: string): string => {
  if (ext === '.pdf') return 'fa-file-pdf';
  if (WORD_EXTS.has(ext)) return 'fa-file-word';
  if (EXCEL_EXTS.has(ext)) return 'fa-file-excel';
  if (PPT_EXTS.has(ext)) return 'fa-file-powerpoint';
  if (IMAGE_EXTS.has(ext)) return 'fa-file-image';
  if (AUDIO_EXTS.has(ext)) return 'fa-file-audio';
  if (VIDEO_EXTS.has(ext)) return 'fa-file-video';
  if (ARCHIVE_EXTS.has(ext)) return 'fa-file-zipper';
  return 'fa-file';
};

/** Format KB value to human-readable size */
export const formatFileSize = (kb: number): string => {
  if (kb === 0) return '0 KB';
  if (kb < 1024) return `${kb.toFixed(kb < 10 ? 1 : 0)} KB`;
  const mb = kb / 1024;
  if (mb < 1024) return `${mb.toFixed(1)} MB`;
  return `${(mb / 1024).toFixed(1)} GB`;
};

const VALID_LAYOUTS = new Set<FileCardLayout>(['default', 'sample', 'button']);

export const parseFileCardProps = (properties: Record<string, any>): FileCardAttrs => {
  const layout = VALID_LAYOUTS.has(properties.dataLayout) ? (properties.dataLayout as FileCardLayout) : 'default';

  return {
    ...parseDataAttrs<FileCardAttrs>(properties, {
      title: '',
      description: '',
      size: 0,
      ext: '',
      url: '',
      customPaperType: '',
      workTypeLabel: '',
      academicLevelLabel: '',
      paperTypeLabel: '',
      citationStyleLabel: '',
      lineSpacingLabel: '',
      disciplineLabel: '',
      fileId: null,
      workType: 1, // default: Writing / Schreiben
      academicLevel: null,
      paperType: null,
      citationStyle: null,
      lineSpacing: null,
      discipline: null,
      spezifikation: null,
      pages: null,
      withOrderForm: false,
      buttonVariant: 'primary',
    }),
    layout,
  };
};
